import { ReactNode } from 'react';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { Breakpoint } from '../helpers';
import { tokens } from '../theme/tokens';
import { FlexGap } from './FlexGap';
import { Heading, Subheading } from './Text';

const Index = styled(Box)<{ $warning?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 26px;
	height: 26px;
	flex-shrink: 0;
	margin-top: ${tokens.gap.inline}px;
	border-radius: ${tokens.radius.full}px;
	background: ${(props) => (props.$warning ? tokens.warning.icon : tokens.text.primary)};
	color: ${tokens.text.inverse};
	font-family: ${tokens.typography.fontFamily};
	font-size: ${tokens.typography.sizes.body}px;
	font-weight: ${tokens.typography.weights.bold};
`;

const Copy = styled(Box)`
	flex: 1 1 auto;
	min-width: 0;
	margin-top: 6px;

	@media screen and (max-width: ${Breakpoint.Medium}) {
		${Heading}, ${Subheading} {
			font-size: ${tokens.typography.sizes.h3}px;
		}
	}
`;

const Row = styled(FlexGap)`
	@media print {
		margin-bottom: 0 !important;
	}
`;

export function NumberedSubheading(props: {
	children: ReactNode;
	index: number;
	showWarningBackground?: boolean;
}) {
	const hasHeading = typeof props.children !== 'string' && typeof props.children !== 'number';

	const title = hasHeading ? props.children : <Subheading>{props.children}</Subheading>;

	return (
		<Row alignItems="flex-start" gap={tokens.gap.group} mb={3}>
			<Index $warning={props.showWarningBackground}>{props.index}</Index>
			<Copy>{title}</Copy>
		</Row>
	);
}
